import axios from 'axios';
import toastr from 'toastr';

const endpoint = 'https://slot.tizeti.com/geniatechapi/index.php';

export const get_bizdev_active_inactive_by_zone = async (initialState) => {
  const formData = new FormData();

  // Add all properties from initialState to the FormData object
  Object.entries(initialState).forEach(([key, value]) => {
    formData.append(key, value);
  });

  try {
    // Let axios handle the content-type automatically for FormData
    const res = await axios.post(endpoint, formData);
    if (res.data) {
      // console.log(res.data);
      return res.data;
    }
  } catch (error) {
    console.error(error);
    toastr.error('error fetching data');
  }
};
